import { FormsService } from "../../../services/forms/forms.service";
import { UpdatePaymentRequestActionType } from "../types";

export function* updatePaymentOption({ payload }: UpdatePaymentRequestActionType) {
    try {
        const {
            data: { data: response },
        } = yield FormsService.updatePaymentSettings({ data: payload.data });
        if (!payload.paymentID) {
            window.declareFields({ "payment.paymentID": response });
            window.handleChange({ id: "payment.paymentID", value: response });
        }
    } catch (error) {
        // yield put(Handle Error);
    }
}
